$(function(){

	console.log('%c Rich Cronin', 'font-size: 24px; color: #455CE9');
	console.log('%c richcronin.co.uk', 'font-size: 12px; color: #455CE9');

	const body 				= $('body');
	const header 			= $('.site-header');
	const tablet_breakpoint = 1100;
	const mobile_breakpoint = 768;

	if ($(window).width() < tablet_breakpoint) {

		$(document).on('click', '.device-menu-trigger', function(){

			body.toggleClass('menu-expanded');

		});

	}

	// function getParameterByName( name ) {
    //   name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    //   var regexS = "[\\?&]"+name+"=([^&#]*)";
    //   var regex = new RegExp( regexS );
    //   var results = regex.exec( window.location.href );
    //   if( results == null )
    //     return "";
    //   else
    //     return decodeURIComponent(results[1].replace(/\+/g, " "));
    // }

    // let lastScrollTop = 0;

	// $(window).on('scroll', function () {
	//   const scrollTop = $(this).scrollTop();

	//   if (scrollTop > 100 && scrollTop > lastScrollTop) {
	//     // Scrolling down past 100px
	//     body.addClass('scrolled');
	//   } else if (scrollTop < lastScrollTop) {
	//     // Scrolling up
	//     body.removeClass('scrolled');
	//   }

	//   if (scrollTop > 100 ) {
	//     // Scrolling down past 100px
	//     body.addClass('has_scrolled');
	//   } else {
	//     // Scrolling up
	//     body.removeClass('has_scrolled');
	//   }

	//   lastScrollTop = scrollTop;
	// });


	// // Click outside to close
	// $(document).on('click', function(e) {
	// 	if ( !$(e.target).closest('.header_drawer').length && !$(e.target).closest('.site-header').length ) {
	// 		if ($('.header_drawer').hasClass('expand')) {
	// 			$('.header_drawer').removeClass('expand');
	// 			console.log('closed (click)');
	// 			if ($(window).width() < tablet_breakpoint) {
	// 				$('.device-search-link').removeClass('open');
	// 				$('.header_drawer').removeClass('expanded');
	// 			}
	// 		}
	// 		$('[data-toggle-search] .link--with-icon-label').text('Search');
	// 		body.removeClass('kill_inverted_header');
	// 	}
	// });

	// // Mouse leave from both
	// // $('.header_drawer, .site-header').on('mouseleave', function() {
	// //   // Check if the mouse left BOTH elements
	// //   if (
	// //     !$('.header_drawer:hover').length &&
	// //     !$('.site-header:hover').length
	// //   ) {
	// //     if ($('.header_drawer').hasClass('expand')) {
	// //       $('.header_drawer').removeClass('expand');
	// //       console.log('closed (mouseleave)');
	// //     }
	// //   }
	// // });



	// $(document).on('click', '[data-toggle-search]', function(e) {
		
	// 	e.preventDefault();
	// 	// if ($(window).width() < tablet_breakpoint) {
	// 	// 	$('.header_drawer').removeClass('expand');
	// 	// }
	// 	$('[data-drawer-search]').toggleClass('expand');
	// 	const $label = $(this).find('.link--with-icon-label');
	// 	const currentText = $label.text().trim();
	// 	$label.text(currentText === 'Search' ? 'Close' : 'Search');

	// 	if ($(window).width() < tablet_breakpoint) {
	// 		$('.device-search-link').toggleClass('open');
	// 		$('.header_drawer[data-drawer-search]').removeClass('expanded');
	// 		body.removeClass('menu-expanded')
	// 	}

	// 	if ( body.hasClass('inverted_header') ){
	// 		body.toggleClass('kill_inverted_header');
	// 	}

	// });

	// $(document).on('click', '[data-navblocktype="menu-style-1"], [data-navblocktype="menu-style-2"]', function(e){

	// 	e.preventDefault();
	// 	var block_id = $(this).data('block-id');
	// 	console.log(block_id);
	// 	$('.header_drawer').removeClass('expand');
	// 	$('.header_drawer[data-block-id="'+block_id+'"]').addClass('expand');

	// 	if ( body.hasClass('inverted_header') ){
	// 		body.addClass('kill_inverted_header');
	// 	}

	// });

	// $(document).on('click', '[data-mobile-menu-toggle]', function(e){

	// 	e.preventDefault();
	// 	body.toggleClass('menu-expanded');

	// });

	// $(document).on('click', '[data-nav-restart]', function(e){

	// 	e.preventDefault();
	// 	$('.header_drawer').removeClass('expand');

	// });

	// $(document).on('click', '[data-toggle-cart]', function(e){

	// 	e.preventDefault(); 
	// 	body.toggleClass('cart-drawer-expanded');

	// });

	// $(document).on('click', '.cart__remove-button', function (e) {
	//   e.preventDefault();

	//   const $btn = $(this);
	//   const name = $btn.attr('name'); // e.g. updates[56110696923520:token]
	//   const matches = name.match(/updates\[(\d+):.*?\]/);

	//   if (!matches || !matches[1]) return;

	//   const lineItemId = matches[1];

	//   $.ajax({
	//     type: 'POST',
	//     url: '/cart/change.js',
	//     data: {
	//       id: lineItemId,
	//       quantity: 0
	//     },
	//     dataType: 'json',
	//     success: function (cart) {
	//       // 🔁 Reload the cart section (adjust ID as needed)
	//       $.get('/cart', function (data) {
	//         const updatedCart = $(data).find('#cart-rerender').html();
	//         $('#cart-rerender').html(updatedCart);
	//         var cartCount = $('.cart-output .item').length;
	//   		$('.cart-drawer .head [data-cart-count]').text(cartCount);
	//       });
	//     },
	//     error: function (err) {
	//       console.error('Remove failed:', err);
	//     }
	//   });

	// });

	// // $(document).on('click', '.product-detail .device-modal-trigger', function(e){

	// // 	e.preventDefault();
	// // 	$('.product-detail .form--container .device-modal').show();

	// // });
	


    // // $(document).on('click', '.j-menu-toggle', function(){

    // // 	let menuLabel = $('.site-header .main-header .inner .menu-toggle .menu-label');
    // // 	body.toggleClass('menu-expanded');
    // // 	let newText = menuLabel.text().trim() === 'Menu' ? 'Close' : 'Menu';
    // // 	menuLabel.text(newText);

    // // });

    // // if ($(window).width() < tablet_breakpoint) {

	// //     $(document).on('click', '.site-header .main-header .megamenu nav ul .parent a.a-parent', function(e){

	// //     	e.preventDefault();
	// //     	$(this).parent().toggleClass('expanded');

	// //     });

	// // }

	// // if ($(window).width() < mobile_breakpoint) {

	// // 	$(document).on('click', '.site-footer .middle nav ul .a a.a-link', function(e){

	// //     	e.preventDefault();
	// //     	$(this).parent().toggleClass('expanded');

	// //     });

	// // }

    // // if ($(window).width() < tablet_breakpoint) {
    // // }

    // // var cartOpen = getParameterByName("cart");

    // // if ( cartOpen.length ){
    // // 	body.addClass('cart-expanded');
	// // }

});